"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleEditSearchModel = instanceOfRoleEditSearchModel;
exports.RoleEditSearchModelFromJSON = RoleEditSearchModelFromJSON;
exports.RoleEditSearchModelFromJSONTyped = RoleEditSearchModelFromJSONTyped;
exports.RoleEditSearchModelToJSON = RoleEditSearchModelToJSON;
exports.RoleEditSearchModelToJSONTyped = RoleEditSearchModelToJSONTyped;
/**
 * Check if a given object implements the RoleEditSearchModel interface.
 */
function instanceOfRoleEditSearchModel(value) {
    return true;
}
function RoleEditSearchModelFromJSON(json) {
    return RoleEditSearchModelFromJSONTyped(json, false);
}
function RoleEditSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'ugNo': json['ugNo'] == null ? undefined : json['ugNo'],
        'ugName': json['ugName'] == null ? undefined : json['ugName'],
        'ugActive': json['ugActive'] == null ? undefined : json['ugActive'],
    };
}
function RoleEditSearchModelToJSON(json) {
    return RoleEditSearchModelToJSONTyped(json, false);
}
function RoleEditSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'ugNo': value['ugNo'],
        'ugName': value['ugName'],
        'ugActive': value['ugActive'],
    };
}
